// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src\\pages\\jobStatus\\JobStatus.css */
.tab-content {
    display: flex;
    flex-direction: column;
  }
  
  .tab-pane {
    display: none;
    padding: 20px;
    /* Rest of your styles */
  }
  
  .tab-pane.active {
    display: block;
  }
  /* src/pages/jobStatus/JobStatus.css */
.button-active {
  background-color: #4caf50; /* Or any color that fits your design */
  color: white;
  /* Add other styles for active button if needed */
}

/* Add this to your JobStatus.css */
.filter-buttons {
  display: flex;
  justify-content: center; /* Center the buttons */
  margin: 1rem 0; /* Add some margin around the button container */
}

.filter-button { /* If you want specific styles for these buttons */
  background-color: #2c3e50; /* Dark blue background */
  border: none; /* Remove border */
  padding: 0.75rem 1.5rem; /* Larger padding for a pill-like shape */
  margin: 0 0.25rem; /* Space out items */
  font-size: 1rem; /* Larger font size */
  color: #ecf0f1; /* Light text */
  cursor: pointer;
  transition: background-color 0.3s ease, transform 0.3s ease;
  border-radius: 20px; /* Rounded corners for pill-like shape */
}

/* Add any specific styles for the active state of the filter buttons if needed */
.filter-button-active {
  background-color: #1abc9c; /* Some greenish blue for active state */
  color: white;
  transform: scale(1.05);
}
`, "",{"version":3,"sources":["webpack://./src/pages/jobStatus/JobStatus.css"],"names":[],"mappings":"AAAA,sCAAsC;AACtC;IACI,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,aAAa;IACb,aAAa;IACb,wBAAwB;EAC1B;;EAEA;IACE,cAAc;EAChB;EACA,sCAAsC;AACxC;EACE,yBAAyB,EAAE,uCAAuC;EAClE,YAAY;EACZ,iDAAiD;AACnD;;AAEA,mCAAmC;AACnC;EACE,aAAa;EACb,uBAAuB,EAAE,uBAAuB;EAChD,cAAc,EAAE,gDAAgD;AAClE;;AAEA,iBAAiB,kDAAkD;EACjE,yBAAyB,EAAE,yBAAyB;EACpD,YAAY,EAAE,kBAAkB;EAChC,uBAAuB,EAAE,yCAAyC;EAClE,iBAAiB,EAAE,oBAAoB;EACvC,eAAe,EAAE,qBAAqB;EACtC,cAAc,EAAE,eAAe;EAC/B,eAAe;EACf,2DAA2D;EAC3D,mBAAmB,EAAE,wCAAwC;AAC/D;;AAEA,iFAAiF;AACjF;EACE,yBAAyB,EAAE,wCAAwC;EACnE,YAAY;EACZ,sBAAsB;AACxB","sourcesContent":["/* src\\pages\\jobStatus\\JobStatus.css */\n.tab-content {\n    display: flex;\n    flex-direction: column;\n  }\n  \n  .tab-pane {\n    display: none;\n    padding: 20px;\n    /* Rest of your styles */\n  }\n  \n  .tab-pane.active {\n    display: block;\n  }\n  /* src/pages/jobStatus/JobStatus.css */\n.button-active {\n  background-color: #4caf50; /* Or any color that fits your design */\n  color: white;\n  /* Add other styles for active button if needed */\n}\n\n/* Add this to your JobStatus.css */\n.filter-buttons {\n  display: flex;\n  justify-content: center; /* Center the buttons */\n  margin: 1rem 0; /* Add some margin around the button container */\n}\n\n.filter-button { /* If you want specific styles for these buttons */\n  background-color: #2c3e50; /* Dark blue background */\n  border: none; /* Remove border */\n  padding: 0.75rem 1.5rem; /* Larger padding for a pill-like shape */\n  margin: 0 0.25rem; /* Space out items */\n  font-size: 1rem; /* Larger font size */\n  color: #ecf0f1; /* Light text */\n  cursor: pointer;\n  transition: background-color 0.3s ease, transform 0.3s ease;\n  border-radius: 20px; /* Rounded corners for pill-like shape */\n}\n\n/* Add any specific styles for the active state of the filter buttons if needed */\n.filter-button-active {\n  background-color: #1abc9c; /* Some greenish blue for active state */\n  color: white;\n  transform: scale(1.05);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
